import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organizations/$organizationId/parent/help-center")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/organizations/$organizationId/parent/help-center"!</div>;
}
